import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FloatLabelModule } from 'primeng/floatlabel';

@Component({
  selector: 'allas-contact-input',
  imports: [CommonModule, FormsModule, FloatLabelModule],
  template: `
    <p-floatlabel variant="on">
      @if (type === 'textarea') {
      <textarea
        [(ngModel)]="value"
        (change)="onChange($event)"
        [id]="id"
        [placeholder]="placeholder"
        rows="6"
        class="w-full p-4 border border-gray-600 focus:ring-1 focus:ring-allasRed focus:border-allasRed transition-all duration-200 bg-white outline-none resize-none"
        [class.border-red-500]="!isValid"
      ></textarea>
      } @else {
      <input
        type="text"
        [(ngModel)]="value"
        (change)="onChange($event)"
        [id]="id"
        [placeholder]="placeholder"
        class="w-full p-4 border border-gray-600 focus:ring-1 focus:ring-allasRed focus:border-allasRed transition-all duration-200 bg-white outline-none"
        [class.border-red-500]="!isValid"
      />
      }
      <label [for]="id">{{ label }}</label>
    </p-floatlabel>

    @if (!isValid) {
    <div class="mt-1 text-sm text-red-600">{{ label }} es requerido *</div>
    }
  `,
})
export class AllasContactInput {
  @Input() id: string = '';
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() value: string = '';
  @Input() dirty: boolean = false;
  @Input() type: 'input' | 'textarea' = 'input';
  @Input() fullWidth: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  get isValid() {
    if (!this.dirty) return true;

    return this.value.trim();
  }

  onChange(event: any) {
    this.dirty = true;
    this.valueChange.emit(event.target.value);
  }
}
